import { FC } from 'react';
import { css } from '@emotion/react';

import { rem } from '@app/styles/theme/layout';

import { AlertItem } from '../hooks/useAlerts';
import { Alert } from './Alert';

const Alerts: FC<{ alerts: AlertItem[] }> = ({ alerts }) => (
  <div>
    {alerts.map(({ content, ...props }, index) => (
      <Alert
        {...props}
        css={css`
          &:not(:last-of-type) {
            margin-bottom: ${rem(16)};
          }
        `}
        data-testid={`alert-${props.type}`}
        key={index}
      >
        {content}
      </Alert>
    ))}
  </div>
);

export default Alerts;
